import React from 'react';
import { TextInput, Edit, SimpleForm } from 'react-admin';

const HealthSystemEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <SimpleForm>
      <TextInput label="Health System Name" source="name" />
      <TextInput label="Health System Label" source="label" />
    </SimpleForm>
  </Edit>
);

export default HealthSystemEdit;
